import "./App.css";
// import Navbar from './components/navbar/Navbar'
import Index from "./components/Home/Index";
import Contact from "./components/Contact/Contact";
import Footer from "./components/footer/Footer";
import Blog from "./components/blog/Blog";
import CustomerRegister from "./components/Authentication/CustormerAuth/Register/CustomerRegister";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import CustomerLogin from "./components/Authentication/CustormerAuth/Login/CustomerLogin";
import PharmacyRegister from "./components/Authentication/PharmacyAuth/Register/PharmacyRegister";
import PharmacyLogin from "./components/Authentication/PharmacyAuth/Login/PharmacyLogin";
import DoctorLogin from "./components/Authentication/DoctorAuth/Login/DoctorLogin";
import DoctorRegister from "./components/Authentication/DoctorAuth/Register/DoctorRegister";
import AdminLogin from "./components/Authentication/Admin/Login/AdminLogin";
import PageNotFound from "./components/pageNotFound/PageNotFound";
import { AuthContext } from "./context/auth";
import PrivateRoute from "./PrivateRoute";
import DashBoard from "./components/dashboard/DashBoard";
// import NavBar from './components/nav-bar/NavBar';

function App() {
  return (
    <AuthContext.Provider value={false}>
      <Router>
        <div className="App">
          <Switch>
            <Route path="/" exact component={Index} />
            <Route path="/contact" component={Contact} />
            <Route path="/blog" component={Blog} />
            <Route path="/Admin/Login" component={AdminLogin} />
            <Route path="/customer/register" component={CustomerRegister} />
            <Route path="/customer/login" component={CustomerLogin} />
            <Route path="/pharmacy/register" component={PharmacyRegister} />
            <Route path="/pharmacy/login" component={PharmacyLogin} />
            <Route path="/doctor/register" component={DoctorRegister} />
            <Route path="/doctor/login" component={DoctorLogin} />
            <PrivateRoute path="/dashboard" component={DashBoard}/>
            <Route component={PageNotFound} />
          </Switch>
        </div>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
